// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Box, Typography } from '@mui/material';

interface TextLogoProps {
  size: 'small' | 'medium' | 'large';
  text: string;
}

type Sizes = Record<TextLogoProps['size'], { main: 'h1' | 'h3' | 'h6'; sub: number }>;

const TextLogo: React.FC<TextLogoProps> = ({ size, text }) => {
  const sizes: Sizes = {
    small: { main: 'h6', sub: 6 },
    medium: { main: 'h3', sub: 9 },
    large: { main: 'h1', sub: 12 },
  };

  return (
    <Box display="inline-flex">
      <Typography
        color="primary"
        variant={sizes[size].main}
        alignSelf="end"
        sx={{ display: 'inline-block', overflow: 'visible', textWrap: 'nowrap' }}
      >
        {text}
      </Typography>
      <Typography
        mt="auto"
        color="primary"
        fontSize={sizes[size].sub}
        fontWeight="bold"
        sx={{ pl: 0.5 }}
      >
        TM
      </Typography>
    </Box>
  );
};

export default TextLogo;
